export const employees = {
	filters: {
		sells: {
			label: "Ventas",
			shortName: "Ventas",
			quantity: "Cantidad de pedidos",
			total: "Valor total de los pedidos",
			average: "Promedio por empleado",
			best: "Mejor desempeño",
			lower: "Menor desempeño",
		},
		financialOperations: {
			label: "Recibos financieros",
			shortName: "Recibos",
			quantity: "Cantidad de operaciones",
			total: "Productos vendidos",
			average: "Promedio por empleado",
			best: "Mejor desempeño",
			lower: "Menor desempeño",
		},
		tips: {
			label: "Propinas",
			shortName: "Propinas",
			total: "Propina total",
			percent: "% sobre la venta",
			average: "Promedio por empleado",
			higher: "Mayor valor",
			lower: "Menor valor",
		},
		refunds: {
			label: "Reembolsos",
			shortName: "Reembolsos",
			quantity: "Cantidad de reembolsos",
			total: "Valor total de los reembolsos",
		},
		sellRefunds: {
			label: "Quién causó el reembolso",
			shortName: "Reembolso",
		},
		checkins: {
			label: "Check-ins",
			shortName: "Check-ins",
			quantity: "Cantidad de Check-ins total",
			average: "Promedio por empleado",
			higher: "Empleado con más Check-ins",
			lower: "Empleado con menos Check-ins",
		},
	},
	userCard: {
		employeeName: "nombre del empleado",
		role: "Puesto",
		ofSales: "de las ventas",
	},
};
